import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class MediaConfigurationApi {
  createMediaConfiguration(data, config) {
    return axios.post(BASE_URL + "/admin/media-config/create", data, config)
  }

  getMediaConfiguration(config) {
    return axios.get(BASE_URL + "/admin/media-config/get", config)
  }
}

const mediaConfigurationApi = new MediaConfigurationApi()
export default mediaConfigurationApi
